export default __webpack_public_path__ + "static/media/icon-chevron-down.be0d3714.svg";